<div class="bu-la-select-container">
  <div class="spinner" *ngIf="isLoading">
    <app-loader></app-loader>
  </div>
  
  <div class="dialog-content">
    
    <div class="form-section">
      <div class="input-group">
        <mat-form-field class="bu-select-field">
          <mat-label>{{BuLabelName}}</mat-label>
          <mat-select [(ngModel)]="selectedBU" name="BUList" (ngModelChange)="loadBULinkedAccounts()">
            @for (bu of BUList; track bu) {
              <mat-option [id]="bu" [value]="bu.buCode">{{bu.buName}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      
      <div class="input-group">
        <app-virtual-autocomplete 
          [dataValues]="accountListSubject.asObservable()" 
          (selectedValues)="onAccountSelectionChange($event)" 
          placeholder="Select Accounts"
          class="account-select">
        </app-virtual-autocomplete>
      </div>
    </div>
    
    <button class="close" mat-flat-button color="primary" [disabled]="disabilityCheck()"
    (click)="addAccountFilter();close()" style="display: none;">Select</button>
  </div>
</div>
